//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

const RbPayOverTimePanelAndModal = () =>
  import(
    /* webpackChunkName: "pay-over-time" */ '@/elements/pay-over-time/rb-pay-over-time-panel-and-modal.vue'
  )
import wcs from '@/scripts/libs/wcs'
import { WcsLocales } from '@/scripts/libs/wcs/types/locales'
import { mapGetters } from 'vuex'
import { KLARNA, PAYPAL, AFTERPAY } from '@/scripts/constants/pay-over-time'
const {
  payOverTime: { afterpay, klarna, payPal },
  locale,
} = wcs.getStoreConfig()
const COMMA = ','

export default {
  name: 'rb-pay-over-time',
  components: {
    RbPayOverTimePanelAndModal,
  },
  data() {
    return {
      visible: false,
      klarna: KLARNA,
      paypal: PAYPAL,
      afterpay: AFTERPAY,
    }
  },
  computed: {
    ...mapGetters(['cartIsLoading']),
    isVisible() {
      return this.afterpayVisible || this.klarnaVisible || this.paypalVisible
    },
    klarnaVisible() {
      const klarnaIsEnabled =
        klarna.onSiteMessagingEnabled &&
        WcsLocales.getLocalizedMessage(klarna.localizedMessage, locale)
      return klarnaIsEnabled
    },
    paypalVisible() {
      const payPalIsEnabled =
        payPal.enabled && WcsLocales.getLocalizedMessage(payPal.localizedMessage, locale)
      return payPalIsEnabled
    },
    afterpayVisible() {
      const afterpayIsEnabled =
        afterpay.enabled && WcsLocales.getLocalizedMessage(afterpay.localizedMessage, locale)
      return afterpayIsEnabled
    },
    count() {
      const count =
        (this.afterpayVisible ? 1 : 0) + (this.klarnaVisible ? 1 : 0) + (this.paypalVisible ? 1 : 0)
      return count
    },
    payPalSeparator() {
      if (!this.paypalVisible || this.count === 1) {
        return ''
      }
      return this.count === 2 ? this.$t('pay_over_time.or') : COMMA
    },
    klarnaSeparator() {
      if (!this.klarnaVisible || this.count === 1) {
        return ''
      }
      if ((this.count === 2 && this.afterpayVisible) || this.count === 3) {
        return this.$t('pay_over_time.or')
      }
      return ''
    },
    isPdp() {
      return wcs.isInPdp()
    },
    canShowSkeletonInCart() {
      return wcs.isInCart() && this.cartIsLoading
    },
  },
  mounted() {
    window.externalInvocationMethodMapping.showPayOverTimeModaOrPanel = () => {
      this.openPayOverTimeModalOrPanel()
    }
  },
  methods: {
    openPayOverTimeModalOrPanel() {
      this.visible = true
    },
    closePayOverTimeModalOrPanel() {
      this.visible = false
    },
  },
}
